import React from 'react';
import cn from 'classnames';
import { bool, number, oneOfType } from 'prop-types';
import { getContext } from '@fiverr-private/fiverr_context';
import Popover from '../Popover';
import { DELAY_MS } from './constants';
import classes from './index.module.scss';

const { POSITIONS, TRIGGERS } = Popover;

/**
 * @deprecated Please use Tooltip from @fiverr-private/tooltip instead.
 */
const Tooltip = ({
    className: customClassName, // eslint-disable-line react/prop-types,
    boxClassName: customBoxClassName, // eslint-disable-line react/prop-types,
    boxContentClassName: customBoxContentClassName, // eslint-disable-line react/prop-types,
    content, // eslint-disable-line react/prop-types,
    delay,
    withAnimation,
    ...rest
}) => {
    const popoverDelay = (typeof delay === 'number') ? delay : (delay && DELAY_MS || 0);
    const className = cn(
        classes.tooltip,
        customClassName
    );

    const boxClassName = cn(
        classes.box,
        customBoxClassName
    );

    const boxContentClassName = cn(
        classes.boxContent,
        customBoxContentClassName
    );

    const { isMobile, isTouch } = getContext();

    const trigger = isTouch ? TRIGGERS.CLICK : TRIGGERS.HOVER;

    return (
        <Popover className={className}
            key={delay.toString()}
            delay={popoverDelay}
            content={content}
            fullWidth={isMobile}
            boxFitContent={false}
            trigger={trigger}
            position={POSITIONS.TOP}
            boxClassName={boxClassName}
            boxContentClassName={boxContentClassName}
            withAnimation={withAnimation}
            {...rest}/>
    );
};

Tooltip.displayName = 'Tooltip';

Tooltip.propTypes = {
    /**
     * Delays the tooltip for a second before opening.
     * Still supports boolean for legacy usage.
     */
    delay: oneOfType([number, bool]),
    /**
     * Whether the tooltip's popover box should be animated.
     */
    withAnimation: bool
};

Tooltip.defaultProps = {
    delay: DELAY_MS,
    withAnimation: true
};

const { delay, ...restPopoverProptypes } = Popover.propTypes;
Object.assign(Tooltip.propTypes, restPopoverProptypes);
Object.assign(Tooltip, {
    POSITIONS
});

export default Tooltip;
